import { AuthFrame } from "./AuthFrame";

export const LoginPage = () => <AuthFrame view="login" />;
